/** @jsxImportSource theme-ui */
import { gql } from "@apollo/client";
import { Box, Link, SemiTitle, Text } from "@bottlebooks/gatsby-theme-base/src";
import { graphql } from "~/gql";
import FacebookVideo from "./FacebookVideo";
import InstagramVideo from "./InstagramVideo";
import VimeoVideo from "./VimeoVideo";
import YouTubeVideo from "./YouTubeVideo";
import PolyvideoVideo from "./PolyvideoVideo";

/**
 *
 * @param {object} props
 * @param {'YOUTUBE' | 'VIMEO' | 'FACEBOOK' | 'INSTAGRAM' | 'POLYVIDEO' | 'OTHER'} props.type
 * @param {string} props.videoId
 * @param {string} [props.title]
 * @param {string} props.url
 * @returns
 */
export default function Video({ type, videoId, title, url, ...rest }) {
  if (!hasContent) return null;
  switch (type) {
    case "YOUTUBE":
      return (
        <YouTubeVideo videoId={videoId} title={title} url={url} {...rest} />
      );
    case "VIMEO":
      return <VimeoVideo videoId={videoId} title={title} url={url} {...rest} />;
    case "FACEBOOK":
      return (
        <FacebookVideo videoId={videoId} title={title} url={url} {...rest} />
      );
    case "INSTAGRAM":
      return (
        <InstagramVideo videoId={videoId} title={title} url={url} {...rest} />
      );
    case "POLYVIDEO":
      return (
        <PolyvideoVideo videoId={videoId} title={title} url={url} {...rest} />
      );
    default:
      return <OtherVideo title={title} url={url} {...rest} />;
  }
}
Video.hasContent = hasContent;
function hasContent(video) {
  if (!video) return false;
  if (video.videoId) return true;
  if (video.url) return true;
  return false;
}

function OtherVideo({ url, title, ...rest }) {
  return (
    <Box {...rest}>
      <SemiTitle>{title}</SemiTitle>
      <Text>
        <Link href={url} target="_blank" rel="noopener noreferrer">
          {url}
        </Link>
      </Text>
    </Box>
  );
}

export const fragment = graphql(`
  fragment bb_Video on Bottlebooks_Video {
    title
    url(format: URL)
    type
    videoId
  }
`);

Video.fragment = gql`
  fragment Video on Video {
    title
    url(format: URL)
    type
    videoId
  }
`;
